<template>
  <div>
    <v-dialog v-model="dialog" :fullscreen="isMobile" :max-width="!isMobile?'1200px':''"
              transition="dialog-bottom-transition">
      <v-card class="background">
        <event-card v-if="activeEvent" :key="activeEvent.Event_ID" :event-id="activeEvent.Event_ID">
          <template v-slot:beforeTitle>
            <v-btn icon @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </event-card>
      </v-card>
    </v-dialog>


    <v-data-iterator class="pa-0" v-if="((isMobile || showList) && !disableGrouping) " hide-default-footer
                     disable-pagination :items="events"
                     :sort-desc="sortDesc"
                     no-data-text="Δεν υπάρχουν γεγονότα"
                     :sort-by="sortBy" sort-desc group-desc :group-by="groupBy">
      <template v-slot:default="props">
        <v-list :key="group.name" v-for="group in props.groupedItems" :max-height="maxHeight" style="overflow-y: auto">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title><strong> {{ group.name }} </strong> ({{ group.items.length }})</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <event-mobile-item @click="rowClick(e)" v-for="e in group.items"
                             :key="e.Event_ID"
                             :item="e"
                             :list-type="listType"
                             :show-date-end="e.EventType_ID === 1"
                             :hide-insert-date="e.EventType_ID === 1">
          </event-mobile-item>
        </v-list>
      </template>
    </v-data-iterator>

    <v-data-table
        :class="{'hidden':isMobile || showList}"
        :max-height="maxHeight"
        id="event-table-to-print"
        @click:row="rowClick" :headers="headers" :items="events" disable-pagination
        group-desc
        :sort-by="sortBy"
        :sort-desc="sortDesc"
        no-data-text="Δεν υπάρχουν γεγονότα"
        :group-by="groupBy"
        hide-default-footer fixed-header :mobile-breakpoint="0">
      <template v-slot:group.header="{items,group}">
        <td colspan="5" class="text-start">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="text--black">
                <strong>{{ group }} </strong>({{ items.length }})
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </td>
      </template>
      <template v-slot:item.DateEventInsert="{item}">
        <span v-if="item.EventType_ID === 1">{{ item.DateStart | fullDate }}</span>
        <span v-else> {{ item.DateEventInsert | fullDate }}</span>
      </template>
      <template v-slot:item.EventType_ID="{item}">
        <v-chip  v-if="item.EventType_ID === 1" color="maintenance"> Συντήρηση</v-chip>
        <v-chip  v-else-if="item.EventType_ID === 2" color="callout" dark> Βλάβη
        </v-chip>
        <v-chip outlined v-else-if="item.EventType_ID === 3" color="task" dark> Άλλη εργασία
        </v-chip>
      </template>
    </v-data-table>

    <v-list v-if=" showList && disableGrouping" :max-height="maxHeight" style="overflow-y: auto;">
      <event-mobile-item :list-type="listType" v-for="e in events" @click="rowClick(e)" :key="e.Event_ID" :item="e" :show-date-end="e.EventType_ID === 1"
                         :hide-insert-date="e.EventType_ID === 1">
      </event-mobile-item>
    </v-list>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import EventCard from "../../Events/components/EventCard";
import EventMobileItem from "@/views/Events/components/EventMobileItem";
import backButton from "@/wl-core/mixins/backButton";
import SinglePage from "@/components/templates/SinglePage";

export default {

  name: "EventList",
  mixins: [backButton(['dialog'])],
  components: {SinglePage, EventMobileItem, EventCard},
  data: () => ({
    dialog: false,
    activeEvent: null,
    headers: [
      {
        text: 'Hμ/νια ',
        value: 'DateEventInsert',
        filterable: true,
        width: "100"
      },
      {
        text: 'Tύπος',
        value: 'EventType_ID',
        filterable: true,
        width: "100"
      },
      {
        text: 'Περιγραφή',
        value: 'Description',
        filterable: true,
      },
    ]
  }),
  computed: {
    ...mapGetters([
      "isMobile"
    ]),
  },

  methods: {

    rowClick(event) {
        this.dialog = true;
        this.activeEvent = event
    },
  },
  props: {
    maxHeight: {type: String, default: 'auto'},
    showList: {type: Boolean, default: false},
    sortDesc: {type: Boolean, default: false},
    sortBy: {type: Array, default: () => (['DateStart'])},
    events: {type: Array, default: null, required: false},
    groupBy: {type: Array, default: () => (['YearStarted'])},
    disableGrouping: {type: Boolean, default: false},
    listType: {type: String, default: 'normal', required: false},
  }
}
</script>

<style scoped>
.hidden {
  display: none;
}

</style>
